import { useLocalization } from '~/composables/_next/useLocalization';
import { CUSTOMER_GROUP_COOKIE } from '~/constants/customerGroups';
export function useCustomerGroup() {
  var _useLocalization = useLocalization(),
    country = _useLocalization.country;
  var customerGroupCookie = useCookie(CUSTOMER_GROUP_COOKIE, {
    path: '/',
    readonly: process.server,
    maxAge: 60 * 60 * 24 * 365,
    // 1 year,
    default: function _default() {
      if (process.server) {
        var serverEvent = useRequestEvent();
        return serverEvent.context.customerGroup;
      }
    }
  });
  function setCustomerGroup(value) {
    if (!value) {
      return;
    }
    customerGroupCookie.value = value;
  }
  function removeCustomerGroup() {
    customerGroupCookie.value = undefined;
  }
  var isCustomerGroupWithoutVat = computed(function () {
    var _customerGroupCookie$;
    return ((_customerGroupCookie$ = customerGroupCookie.value) === null || _customerGroupCookie$ === void 0 ? void 0 : _customerGroupCookie$.key) === process.env.CUSTOMER_GROUP_WITHOUT_VAT && country !== 'FR';
  });
  return {
    customerGroup: readonly(customerGroupCookie),
    setCustomerGroup: setCustomerGroup,
    removeCustomerGroup: removeCustomerGroup,
    isCustomerGroupWithoutVat: isCustomerGroupWithoutVat
  };
}